import React from 'react'
import Tours from "../Images/Tours.png";

export const IndexPackages = () => {
  return (
    <div className="bg-gradient-to-t from-green-100 to-blue-100 w-full min-h-screen flex flex-col items-center justify-center font-lato">
    <img src={Tours} className="h-44 w-54 mx-auto" />
    <div className="text-center text-xl mt-6">
      Package Services Will be available soon
    </div>
  </div>
  )
}
